import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class FixedIncomeApiHttpProvider extends HttpService {
    constructor(http: HttpClient, settingsService: SettingsService) {
        super('fixedIncomeApi', http, settingsService);
    }
}
